"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR = exports.LIGHT_GRAY = exports.SEA_BLUE = exports.LIME_GREEN = exports.MAGENTA = exports.PURPLE_DARK = exports.PURPLE_LIGHT = exports.PURPLE = exports.GREEN_DARK = exports.GREEN_LIGHT = exports.GREEN = exports.INDIGO_BLUE = exports.BLUE_DARK = exports.BLUE_LIGHT = exports.BLUE = exports.WARNING_ORANGE = exports.ORANGE_DARK = exports.ORANGE_LIGHT = exports.ORANGE = exports.HIGHLIGHT_LIGHT_BLUE = exports.HIGHLIGHT_BLUE = exports.HIGHLIGHT_LIGHT_RED = exports.HIGHLIGHT_RED = exports.LIGHT_GREEN = exports.HIGHLIGHT_GREEN = void 0;
exports.HIGHLIGHT_GREEN = "#60cdb2";
exports.LIGHT_GREEN = "#AFF4B5";
exports.HIGHLIGHT_RED = "#F42A68";
exports.HIGHLIGHT_LIGHT_RED = "#f7728c";
exports.HIGHLIGHT_BLUE = "#3886FF";
exports.HIGHLIGHT_LIGHT_BLUE = "#EEF5FF";
exports.ORANGE = "#fbac3b";
exports.ORANGE_LIGHT = "#FFCF8B";
exports.ORANGE_DARK = "#DD9023";
exports.WARNING_ORANGE = "#FFC069";
exports.BLUE = "#3886FF";
exports.BLUE_LIGHT = "#8BB9FF";
exports.BLUE_DARK = "#246BD9";
exports.INDIGO_BLUE = "#231c5b";
exports.GREEN = "#60cdb2";
exports.GREEN_LIGHT = "#B3F1E2";
exports.GREEN_DARK = "#44A58D";
exports.PURPLE = "#6352ef";
exports.PURPLE_LIGHT = "#978AFF";
exports.PURPLE_DARK = "#3F2FC0";
exports.MAGENTA = "#FD88F8";
exports.LIME_GREEN = "#CEF16B";
exports.SEA_BLUE = "#53BBD8";
exports.LIGHT_GRAY = "#dadbd9";
exports.COLOR = {
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    primary: "#191345",
    "primary-light": "#0056C4",
    "primary-bg": "#EBFAFF",
    secondary: "#03BC9D",
    "secondary-bg": "#E9FCF3",
    error: "#F16B8B",
    "error-bg": "#FFF3F4",
    info: "#D03A5E",
    "info-bg": "#FFEDED",
    success: "#009373",
    "success-bg": "#E9FCF3",
    text: "#606C7E",
    "text-dark": "#182C4C",
    border: "#DEE4EA",
    body: "#FBFBFB",
    "login-button": "#60cdb2",
    "orange-light": "#FFCA5A",
    button: {
        disabled: "#DDDDDD",
    },
    gray: {
        100: "#FAFCFD",
        150: "#F5F5F5",
        180: "#ECF3F9",
        200: "#EEF4F8",
        300: "#DEE4EA",
        400: "#D3DBE2",
        500: "#C6D1D9",
        600: "#C0CCD5",
        700: "#B7C5CF",
        800: "#A1B1C1",
        900: "#72808E",
    },
    blue: {
        100: "#B3F0F7",
        200: "#53BBD8",
        300: "#2796C9",
        400: "#0277BD",
        500: "#0056C4",
        600: "#0E4AA3",
    },
    lightsteelblue: "#d1e9ff", // antd form items border color on focus
    finway: {
        orange: "#fbac3b",
        "orange-dark": "#dd9023",
        "orange-light": "#ffcf8b",
        "orange-light2": "#F79E1B",
        "orange-light3": "#F79E1B0D",
        blue: "#3886ff",
        "blue-dark": "#1a4fa1", // for highlight text
        "blue-light": "#eef5ff",
        "blue-light2": "#e1edff",
        "blue-light3": "#eaf0fa",
        "blue-accent-dark": "#246bd9", // for charts
        "blue-accent-light": "#8bb9ff", // for charts
        red: "#f42a68",
        red2: "#E1426A",
        "red-dark": "#aa1c18",
        "red-faded": "#ffa8c3",
        "red-light": "#fff4f8",
        "red-light2": "#F16B8B",
        green: "#60cdb2",
        "green-dark": "#105816", // for highlight text
        "green-light": "#f0fffb",
        "green-light2": "#60cdb2",
        "green-light3": "#cbfdd0",
        "green-light4": "#AFE6D8", // for charts
        "green-light5": "#34BB9D",
        "green-light6": "#f2fefb",
        "green-accent-dark": "#44a58d", // for charts
        "green-accent-light": "#b3f1e2", // for charts
        "purple-accent": "#6352ef", // for charts
        "purple-accent-light": "#978aff", // for charts
        "purple-accent-dark": "#3f2fc0", // for charts
        primary: "#231c5b",
        "primary-light": "#342a83",
        "primary-light2": "#241a73",
        "primary-light3": "#7b779d",
        secondary: "#2be2c7",
        "alice-blue": "#E7F0F9", // for cashflow table tooltip
        "input-grey": "#E4E4E4",
    },
};
